module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M0 30.252V1.744C0 .16 2.336-.448 3.632.352l23.224 14.18c1.288.808 1.612 2.124.324 2.932L3.468 31.644C2.18 32.452 0 31.832 0 30.252z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/play-3.js
// module id = 1346
// module chunks = 14